<template>
  <div>
    <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor" :router="router"></Header>
    <div class="detailArticle">
      <div ref="breadcrumb" class="breadcrumb-container">
        <el-breadcrumb class="list" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">PaaS平台</el-breadcrumb-item>
          <el-breadcrumb-item class="breadcrumb-point" @click.native="jumpFrontier">前沿</el-breadcrumb-item>
          <el-breadcrumb-item v-if="article.title">
            {{ article.title }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row class="container">
        <el-col :span="15">
          <div class="article-title">{{ article.title }}</div>
          <div class="article-date-source">
            发布时间：{{ article.releaseDate.slice(0, 10) }}<span v-if="article.author !== 'null'">&nbsp;&nbsp;&nbsp;&nbsp;作者:{{ article.author }}</span>
          </div>
          <!-- 免费试用区域 -->
          <div class="trial-section">
            <div class="trial-left">
              <img src="~@/assets/img/frontierPage/hussarLogo.png" alt="试用图标" />
            </div>
            <div class="trial-middle">
              <div class="trial-title">免费试用轻骑兵低代码PaaS平台</div>
              <div class="trial-desc">金现代轻骑兵低代码 PaaS 平台整合零/低代码、AI等全栈技术能力，沉淀可复用数字资产，优化企业 IT 资源配置，加速全场景数字化转型。</div>
            </div>
            <div class="trial-right">
              <button class="trial-btn" @click="openTrialForm">免费试用</button>
            </div>
          </div>
          <div v-html="articleContent" class="articleContent"></div>
          <!-- 获取方案区域 -->
          <div class="article-bottom" @click="openSolutionForm">
            <div class="article-bottom-content">
              <div class="article-bottom-title">轻骑兵低代码PaaS平台</div>
              <div class="article-bottom-desc">已与中国航天科工、中国电建、中信泰富特钢、中泰证券、青岛地铁、福莱特玻璃等众多知名企业达成合作，助力上千家中大型企业完成数字化转型。</div>
            </div>
          </div>
          <div class="tagArticle">
            <div>文章标签</div>
            <div>
              <div @click="jumpTag(item)" v-for="item in article.contentTag" class="tag">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="upper-lower-articles" v-if="arrayAdjacent.length > 0">
            <div v-if="adjacentType !== '1'" class="circular" @click="sectionSwitch(arrayAdjacent[0])">
              上一篇<span class="point">{{arrayAdjacent[0].title}}</span>
            </div>
            <div v-else class="circular">
              上一篇<span style="color: #A7A7A7">没有了</span>
            </div>
            <div v-if="adjacentType !== '2'" class="circular" @click="sectionSwitch(arrayAdjacent[1]) ">
              下一篇
              <span class="point1">{{arrayAdjacent[1].title}}</span>
            </div>
            <div v-else class="circular">
              下一篇<span style="color: #A7A7A7">没有了</span>
            </div>
          </div>
          <div class="recommend">相关推荐</div>
          <el-row>
            <el-col v-for="(item,index) in recommendData" :key="item.id" :span="12" class="recommendItem" :class="recommendData.length > 2 && index  < 2 ? 'bottom-border': ''">
              <div class="recommend-top" @click="sectionSwitch(item)">
                <div class="recommend-number">{{index + 1}}</div>
                <div class="recommend-title">{{item.title}}</div>
              </div>
              <div class="recommend-content" @click="sectionSwitch(item)">{{item.description}}</div>
            </el-col>
          </el-row>
          </el-col>
          <el-col :span="9" class="containerRight">
            <frontier-right-page @jumpTag="jumpTag" @openDetail="openDetail"></frontier-right-page>
          </el-col>
      </el-row>
    </div>
    <!--联系专家-->
    <ContactExperts></ContactExperts>
    <!-- footer -->
    <FhBottom/>
    <!-- 右侧联系方式 -->
    <SideBar @openForm="openForm"></SideBar>
    <!-- 表单 -->
    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
    <TrialForm v-show="showTrialForm" @closeForm="closeForm"></TrialForm>
    <SolutionForm v-show="showSolutionForm" @closeForm="closeForm"></SolutionForm>
    <!-- 返回顶部 -->
    <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
  </div>
</template>

<script>
  import Header from "./include/Header";
  import Footer from './include/Footer.vue';
  import HussarForm from "./include/HussarForm";
  import TrialForm from "./include/TrialForm";
  import SolutionForm from "./include/SolutionForm";
  import ContactExperts from './include/ContactExperts.vue';
  import FrontierRightPage from "./FrontierRightPage";
  import {
    getContentTxtByContentId,
    getContentViewById,
    contentExtByContentId,
    getContentInfoNoPage,
    contentInfoById
  } from "../api/frontierPage";
  import SideBar from "./include/SideBar";
  import router from '@/router/index.js'

  export default {
    name: "FrontierDetailsArticle",
    components: {
      FrontierRightPage,
      Header,
      HussarForm,
      TrialForm,
      SolutionForm,
      Footer,
      SideBar,
      ContactExperts,
    },
    data() {
      return{
        router:'/FrontierPage/FrontierDetailsArticle',
        headColor:"dark",
        isPageScroll: false,
        showForm: false,
        showTrialForm: false,
        showSolutionForm: false,
        arrayAdjacent: [],
        articleContent: '',
        recommendData: [],
        article: {
          id:'',
          title: '',
          releaseDate: '',
          channelId:'',
          contentTag: '',
        },
        frequency: 0,
        serverSrc: "http://www.jxdinfo.com/",
        adjacentType: '', // 1没有上一篇  2没有下一篇
      }
    },
    watch: {},
    methods: {
      openForm() {
        const self = this;
        self.showForm = true;
      },
      openTrialForm() {
        const self = this;
        self.showTrialForm = true;
      },
      openSolutionForm() {
        const self = this;
        self.showSolutionForm = true;
      },
      closeForm() {
        const self = this;
        self.showForm = false;
        self.showTrialForm = false;
        self.showSolutionForm = false;
      },
      jumpFrontier() {
        this.$router.push('/FrontierPage');
      },
      // 返回顶部
      backTop() {
        $('html ,body').animate({scrollTop: 0}, 700);
      },
      // 页面滚动
      handleNavScroll() {
        const self = this;
        self.isPageScroll = false;
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 80) {
          self.isPageScroll = true;
        }
      },
      getContent(item,channelId) {
        this.article = item
        localStorage.setItem('article',JSON.stringify(this.article))
        localStorage.setItem('channelId',this.article.channelId)
        getContentTxtByContentId({
          contentId: item.id,
        }).then((res) => {
          if (res.status === 200) {
            let textareaHtml = res.data;  //从response获取HTML的数据
            var srcReg = /src=([\'\"]?([^\'\"]*)[\'\"]?)/ig;
            if(textareaHtml){
              textareaHtml = textareaHtml.replace(srcReg,"src='"+this.serverSrc+"$2"+"'");
              this.articleContent = textareaHtml;
            }
          }
        });
        getContentViewById({
          contentId: item.id,
        }).then((res) => {
        });
        this.contentExtByContentId()
        this.getContentInfo()
      },
      jumpTag(item) {
        this.$root.frontierTag = item;
        this.$router.push(`/FrontierPage/aboutArticle=${item.id}`);
      },
      sectionSwitch(item) {
        item.channelId = this.article.channelId;
        this.$root.frontierArticle = item;
        this.$router.push(`/FrontierPage/detailsArticle=${item.id}`);
        this.article = item;
        this.getContent(item);
        window.scrollTo({top: 0});
      },
      contentExtByContentId() {
        const self = this
        let storage = new FormData();
        storage.append('contentId', self.article.id);
        storage.append('channelId', self.article.channelId);
        contentExtByContentId(storage).then((res) => {
          if (res.status === 200) {
            let data = res.data;
            if(data.length === 2){
              let index = data.findIndex(item => {
                return item.id === self.article.id
              })
              if(index === 0){
                self.adjacentType = '1'
              }else {
                self.adjacentType = '2'
              }
              self.arrayAdjacent = data
            } else {
              self.adjacentType = ''
              data.splice(1, 1)
              self.arrayAdjacent = data
            }
          }
          this.frequency++;
        });
      },
      getContentInfo() {
        const self = this
        let storage = new FormData();
        storage.append('channelId', this.article.channelId);
        getContentInfoNoPage(storage).then((res) => {
          if (res.status === 200) {
            self.recommendData = res.data.content;
            let index = self.recommendData.findIndex(item => {
              return item.id === self.article.id
            })
            self.recommendData.splice(index,1)
            if(self.recommendData.length > 4){
              self.recommendData = this.getRandomArray( res.data.content,4)
            } else if(self.recommendData.length < 2) {

            }
          }
        });
      },
      getRandomArray(arr, count) {
        var shuffled = arr.slice(0),
          i = arr.length,
          min = i - count,
          temp, index;
        while (i-- > min) {
          index = Math.floor((i + 1) * Math.random());
          temp = shuffled[index];
          shuffled[index] = shuffled[i];
          shuffled[i] = temp;
        }
        return shuffled.slice(min);
      },
      openDetail(item) {
        item.channel = this.article.channelId;
        this.sectionSwitch(item)
      },
      mounteds(){
        this.getContent(this.article, this.article.channelId)
        window.addEventListener('scroll', this.handleNavScroll);
      }
    },
    mounted() {

    },
    created(){
      if(this.$root.frontierArticle.id==undefined||this.$root.frontierArticle.id==null){
        let storage = new FormData()
        var contentId = window.location.pathname.split('=')[1]
        storage.append('contentId', contentId);
        contentInfoById(storage).then((res) => {
          this.article = res.data
          document.title = res.data.title;
          this.mounteds();
        });
      }else {
        this.article = this.$root.frontierArticle
        document.title = this.article.title;
        this.mounteds();
      }
    }
  }
</script>

<style scoped>
  .detailArticle {padding-bottom: 42px;width: 1200px;margin: auto;padding-top: 156px}
  .detailArticle .container .containerRight {padding-left: 80px}
  .breadcrumb-container {margin-top: 42px;}
  .list {font-size: 14px;font-weight: 400;color: #A7A7A7;}
  .list /deep/ .el-breadcrumb__item .el-breadcrumb__inner {color: #a7a7a7 !important;font-weight: 400;}
  .list /deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner {color: #0e0d0d !important;}
  .point {cursor: pointer;}
  .breadcrumb-point {cursor: pointer; color: #0d8eff;}
  /* 免费试用区域 */
  .trial-section {
    display: flex;
    align-items: center;
    background: #FAFAFA;
    padding: 20px;
    margin-bottom: 20px;
  }
  .trial-left {
    flex-shrink: 0;
    margin-right: 16px;
  }
  .trial-left img {
    width: 60px;
    height: 60px;
    border-radius: 8px;
  }
  .trial-middle {
    flex: 1;
  }
  .trial-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
  }
  .trial-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
  }
  .trial-right {
    flex-shrink: 0;
    margin-left: 20px;
  }
  .trial-btn {
    background: url('~@/assets/img/frontierPage/header-button.png') no-repeat;
    background-size: 100% 100%;
    color: #fff;
    border: none;
    padding: 10px 24px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.3s;
  }

  .article-bottom {
    width: 100%;
    height: 126px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url('~@/assets/img/frontierPage/article-bottom.png') no-repeat;
    background-size: 100% 100%;
    color: #fff;
    padding: 20px 210px 20px 156px;
    margin-bottom: 50px;
    cursor: pointer;
  }
  .article-bottom-title {
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 5px;
  }
  .article-bottom-desc {
    font-size: 14px;
    color: #fff;
    line-height: 1.5;
  }
  /* 返回顶部 */
  .back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
  .point1 {text-align: right;cursor: pointer;width: 320px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #0d8eff;}
  .upper-lower-articles {justify-content: space-between;margin-top: 40px;display: flex;width: 750px;}
  .upper-lower-articles  span {color: #0d8eff;margin-left: 10px;}
  .circular {flex: 1;width: 20px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-size: 16px}
  .circular:first-of-type {margin-right: 30px;}
  .tagArticle {align-items: center;display: flex;font-size: 16px}
  .tagArticle span{margin-right: 15px}
  .tag {cursor: pointer;font-size: 14px;margin-left: 10px;display: inline-block;width: max-content;padding: 10px;color: #408cf6;background: url('~@/assets/img/frontierPage/tag.png');background-size: 100% 100%}
  .tag:nth-of-type(n + 2) {margin-left: 10px;}
  .article-date-source {font-size: calc(100vw * 14 / 1920);font-weight: 400;color: #b2b0b0;text-align: left;margin-top: 10px;margin-bottom: 20px;}
  .article-title {text-align: left;margin-top: 20px;margin-bottom: 10px;font-size: 30px;font-weight: bold;color: #3e3a39;}
  .articleContent {margin-bottom: 40px}
  .articleContent > ::v-deep p {line-height: 2;font-size: calc(100vw * 16 / 1920) !important;font-weight: 400 !important;color: #3e3a39 !important;}
  .recommendItem {padding-bottom: 22px;margin-top: 20px;cursor: pointer}
  .bottom-border{border-bottom: 1px solid #eeeeee;}
  .recommend {width: 96px;font-size: 24px;font-weight: bold;color: #3E3A39;margin-top: 60px;margin-bottom: 20px}
  .recommend-top {height: 19px}
  .recommend-number{ float:left;background: url('~@/assets/img/frontierPage/recommend-ellipse.png');width: 19px;height: 19px;display: flex;justify-content: center;align-items: center;color: #fff;}
  .recommend-title {line-height: 19px;width: calc(100% - 29px);text-overflow: ellipsis;overflow: hidden;white-space: nowrap;float: left;margin-left: 10px;font-size: 16px;font-weight: bold;color: #3E3A39;}
  .recommend-content {height: 40px;font-size: 12px;font-weight: 400;color: #707070;line-height: 20px;margin-top: 22px;display: -webkit-box;-webkit-line-clamp: 2;overflow: hidden;-webkit-box-orient: vertical;}
  .recommendItem:nth-of-type(odd) {padding-right: 18px;}
  .recommendItem:nth-of-type(even) {padding-left: 18px;}
</style>




// WEBPACK FOOTER //
// src/components/FrontierDetailsArticle.vue